import { useEffect, useMemo, useRef, useState,useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import AuthContext from '../../AuthContext'
import {Menu ,Paper} from '@mantine/core'
import axios from '../../axios'

import { useNavigate } from 'react-router-dom';
const Example = ({updateProductModalSetting,handlePageUpdate}) => {
  const{centre} =useContext(AuthContext)
  //console.log(centre)
  const navigate=useNavigate()
  const columns = useMemo(
    () => [
      {
        accessorKey: 'centre_name',
        header: 'Centre Name',
        size: 200,
        enableColumnSticky:true
      },
      {
        accessorKey: 'sector_name',
        header: 'Sector Name',
        size: 200,
      },
      {
        accessorKey: 'course_code',
        header: 'Course Code',
        size: 200,
      },
      {
        accessorKey: 'cost',
        header: 'Cost',
        size: 150,
      },
      {
        accessorKey: 'job_role_name',
        header: 'Job Role Name',
        size: 200,
      },
      {
        accessorKey: 'job_role_cate',
        header: 'Job Role Category',
        size: 200,
      },
      {
        accessorKey: 'version',
        header: 'Version',
        size: 150,
      },
      {
        accessorKey: 'course_hour',
        header: 'Duration',
        size: 150,
      },
      
      {
        accessorKey: 'min_quali',
        header: 'Minimum Qualification',
        size: 200,
      },
      {
        accessorKey: 'admin_status',
        header: 'Admin Status',
        size: 150,
      }
      
    ],
    [],
  );

  //optionally access the underlying virtualizer instance
  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);
  const centre_id=JSON.stringify(centre)


  useEffect(() => {
    axios.post('/courses/getAll',{ 
      centre_id:centre
    })
     .then((res) => setData(res.data))
     .catch((err) => console.log(err))
     .finally(() => setIsLoading(false));
  }, [handlePageUpdate,centre]);

  useEffect(() => {
    try {
      //scroll to the top of the table when the sorting changes
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);
const table=useMantineReactTable({
  data,
  columns,
  enableGlobalFilter: true,
  enableColumnFilterModes: true,
  enablePinning: true,
  enablePagination: true,
  enableMultiSort: true, 
  columnFilterDisplayMode:"popover",
  paginationDisplayMode:"pages",
  positionToolbarAlertBanner:"bottom",
  enableColumnResizing: true,
  enableColumnFilter: true,
  enableColumnSelection: true,
  enableGlobalFilter: true,
  enableGlobalFilterModes: true,
  enableStickyHeader: true,
  enableColumnSticky: true,
  enableRowNumbers: true,
  enableRowActions: true,
  renderRowActionMenuItems: ({ row }) => (
    <>
     <Menu.Item  onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>
     <Menu.Item onClick={() => navigate(
          `/courses/details`,{
            state: { course_id: row.original.course_id }
          },
          { replace: true }
        )}>Details</Menu.Item>
    </>
  ),
})

  return <Paper shadow="sm" p="lg" withBorder>
          <div style={{ width: '100%' }}>

  <MantineReactTable
    table={table}
    striped // Enables the striped rows
    highlightOnHover
    horizontalSpacing="md"
    verticalSpacing="sm"
    fontSize="sm"
    withColumnBorders
    borderRadius="md"
    withGlobalFilter
    height={400}
    rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
    enablePagination={true} // Enables pagination

/>
</div>
</Paper>
};

export default Example;